import './style.scss'
import React from 'react'

export interface PreviewOptionProps {
    checked: boolean
    onChange: () => void
    children: React.ReactNode
    className?: string
}

export const PreviewOption: React.FC<PreviewOptionProps> = ({
                                                                checked, onChange, children, className = '',
                                                            }) => (
    <div
        className={`preview-option ${checked ? 'preview-option--checked' : ''} ${className}`}
        onClick={onChange}
    >
        <span className={`preview-option__dot ${checked ? 'is-checked' : ''}`} />
        <div className="preview-option__content">{children}</div>
    </div>
)

export default PreviewOption